import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { SeErrorStateMatcher } from '../../../utils/error-state-matcher';
import { DateInputEnum } from '../../../models/date-input.enum';
import moment from 'moment';
import { SeTimePickerComponent, SeDatetimePickerComponent } from '@se/platform';

/**
 * Base Editor Custom AgGrid for Date/DateTime/Time Input.
 * It contains common functionalities used by DateCellEditorInlineComponent
 * and DateCellEditorPopupComponent
 */
@Component({
    template: ''
})
export class DateCellEditorBaseComponent implements OnInit {
    /**
     * Current value of the cell
     * ngModel setted by DateCellEditorComponent
     */
    @Input() value: moment.Moment;

    /**
     * Type of the input:
     * - datetime
     * - date
     * - time
     */
    @Input() inputType: DateInputEnum;

    /**
     *   set time format
     */
    @Input() timeInputFormat: string;

    /**
     *  (Optional) it allows to specify if the filed is mandatory
     */
    @Input() required: boolean;

    /**
     * width of the cell containing the editor
     */
    @Input() width: string

    /**
     * Event emitted when the reactive form is ready
     */
    @Output() formReady: EventEmitter<FormControl> = new EventEmitter<FormControl>();

    /**
    * Event emitted when the keyboard space key is pressed.
    */
    @Output() spaceBarClick: EventEmitter<Event> = new EventEmitter<Event>();

    @Output() escPressed: EventEmitter<Event> = new EventEmitter<Event>();
    @Output() enterPressed: EventEmitter<Event> = new EventEmitter<Event>();
    @Output() tabToTheNext: EventEmitter<any> = new EventEmitter();




    @ViewChild('dateInput', { static: false, read: ElementRef }) dateInput: ElementRef;

    @ViewChild('seTimePicker') seTimePicker: SeTimePickerComponent;

    @ViewChild('seDateTimePicker') seDateTimePicker: SeDatetimePickerComponent;

    formControl: FormControl;
    matcher = new SeErrorStateMatcher();
    // _inputType: string;

    ngOnInit(): void {

        this.formControl = new FormControl(this.value, this.required ? [Validators.required] : []);

        switch (this.inputType) {
            case DateInputEnum.TIME:
                this.width = "75px";
                break;
            case DateInputEnum.DATE_TIME:
                this.width = "250px";
                break;
            case DateInputEnum.DATE:
            case DateInputEnum.DATE_TIME_OLD:

            default:
                break;
        }
    }

    _updateModel(newVal: any) {
        this.formControl.setValue(newVal);
    }

    _onSpaceBar(event: KeyboardEvent) {
        this.spaceBarClick.emit(event);
    }

    _onTimePickerKeydown(customEvent: { ev: KeyboardEvent, picker: 'date' | 'hour' | 'minute' }): void {
        const { ev, picker } = customEvent
        switch (ev.key) {
            case "Escape":
                this.escPressed.emit(ev);
                break;
            case "Enter":
                this.enterPressed.emit(ev);
                break;
            case "Delete":
                // FIX TIME problema TAB che mette 00:00 dopo CANC --> chiudiamo l'editor
                // per coerenza facciamo chiudere anche DATE TIME
                setTimeout( () =>
                    this.tabToTheNext.emit()
                );
                break;
            case "Tab":
                if (picker === 'date' && !ev.shiftKey) {
                    ev.stopPropagation();
                    this.seDateTimePicker.focusHour();
                }
                if (picker === 'minute' && !ev.shiftKey) {
                    this.tabToTheNext.emit();
                }
                break;
            default:
                break;

        }
    }




}


